// Ebook Grid filter: clicking a filter tag shows only cards whose data-category matches, pure
// client-side (shared mechanics in filterGrid.js).
import initFilterGrid from './filterGrid';

export default function initEbookGrid() {
  initFilterGrid({
    rootSelector: '.section-ebook-grid',
    tagSelector: '.section-ebook-grid__filter-tag',
    itemSelector: '.section-ebook-grid__card',
    emptyText: (label) => 'No ebooks under \u201C' + label + '\u201D yet \u2014 that chapter is still being written. Try another topic.',
  });
}
